<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-cog mr-2" />Biaya Marketplace
            </h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Biaya">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            placeholder="Cari Nama Biaya"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="prepareCreate">
                            <i class="fa fa-plus mr-2" />Biaya Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data biaya marketplace.
                </template>
                <template v-slot:cell(type)="row">
                    <span v-if="row.item.type == 1">Penambahan</span>
                    <span v-else>Pengurangan</span>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        variant="warning"
                        v-b-tooltip.hover.top
                        title="Edit"
                        @click="prepareEdit(row.item)"
                        class="mr-1"
                    >
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button
                        size="sm"
                        variant="danger"
                        v-b-tooltip.hover.top
                        title="Hapus"
                        @click="confirmDelete(row.item)"
                    >
                        <i class="fa fa-fw fa-trash" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-form"
            :title="isEdit ? 'Edit Biaya' : 'Tambah Biaya Baru'"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @hide="clearInput"
        >
            <template v-if="isEdit">
                Mengubah biaya <strong>{{ activeItem.name }}</strong>
            </template>
            <b-form-group :class="isEdit ? 'mt-2' : ''">
                <div>Nama Biaya <span style="color: red;">*</span></div>
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group>
                <div>Tipe Biaya <span style="color: red;">*</span></div>
                <b-form-select id="input-type" v-model="input.type" :options="optType"/>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="confirmSave"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isEdit: false,

            filter: {
                name: ""
            },

            input: {
                name: "",
                type: null
            },

            optType: [
                { value: null, text: "Pilih Tipe Biaya", disabled: true },
                { value: 1, text: "Penambahan" },
                { value: 0, text: "Pengurangan" }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "name", label: "Nama Biaya", sortable: true },
                { key: "type", label: "Tipe Biaya", sortable: false },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        clearInput() {
            this.input = {
                name: "",
                type: null
            };
            this.isEdit = false;
        },

        prepareCreate() {
            this.isEdit = false;
            this.clearInput();
            this.$bvModal.show("m-form");
        },

        prepareEdit(item) {
            this.isEdit = true;
            this.activeItem = item;
            this.input.name = item.name;
            this.input.type = item.type
            this.$bvModal.show("m-form");
        },

        confirmSave() {
            if (this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(
                    this,
                    "Nama tidak boleh kosong!"
                );
            }

            if (this.input.type === null) {
                return this.$helper.toastError(
                    this,
                    "Tipe Biaya harus dipilih!"
                );
            }

            let confirmMsg = this.isEdit
                ? "Simpan perubahan biaya ini?"
                : "Simpan biaya baru ini?";
            let isConfirmed = confirm(confirmMsg);
            if (!isConfirmed) return;

            let payload = {
                name: this.input.name,
                type: this.input.type
            };

            let url = "master/marketplace-fees";
            let method = "post";

            if (this.isEdit) {
                url += "/" + this.activeItem.id;
                method = "put";
            }

            this.isSubmitting = true;
            this.$axios[method](url, payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        `Biaya berhasil ${
                            this.isEdit ? "diubah" : "ditambahkan"
                        }!`
                    );
                    this.$bvModal.hide("m-form");
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmDelete(item) {
            let isConfirmed = confirm(
                `Apakah Anda yakin ingin menghapus biaya "${item.name}"?`
            );
            if (!isConfirmed) return;

            this.isBusy = true;
            this.$axios
                .delete("master/marketplace-fees/" + item.id)
                .then(() => {
                    this.$helper.toastSuccess(this, "Biaya berhasil dihapus!");
                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isBusy = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name;
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("master/marketplace-fees" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        }
    },

    created() {
        this.init();
    }
};
</script>
